import apiService from '@/core/common/services/api.service';
import buildQuery from 'odata-query';
import { add, subDays } from 'date-fns';
import { getUserTeams, getUserTeamsOhneAbteilung } from '@/core/common/helpers/utils.js';
import { getReleaseprozessStatus } from '@/core/produkte/reisetermine/stores/reisetermine.module';
const moment = require('moment');

export const GET_AUFGABEN = 'aufgaben.getAufgaben';
export const INITIALLY_GET_AUFGABEN_NOTIFICATION_COUNT = 'aufgaben.initiallyGetAufgabenNotificationCount';
export const GET_AUFGABEN_NOTIFICATION_COUNT = 'aufgaben.getAufgabenNotificationCount';
export const SET_AUFGABEN_NOTIFICATION_COUNT = 'aufgaben.setAufgabenNotificationCount';
export const SET_AUFGABEN = 'aufgaben.setAufgaben';

export const EDIT_AUFGABE = 'aufgaben.editAufgabe';
export const LOAD_TRIGGERS = 'aufgaben.loadTriggers';
export const EDIT_STATUS = 'aufgaben.editStatus';
export const BULK_EDIT_STATUS = 'aufgaben.bulkEditStatus';
export const CREATE_AUFGABE = 'aufgaben.createAufgabe';

export const SET_IS_BUSY = 'aufgaben.setIsBusy';
export const SET_IS_AUFGABE_UPDATING = 'aufgaben.setIsAufgabeUpdating';
export const SET_TIME_UPDATED = 'aufgaben.setTimeUpdated';
export const SET_AUFGABE_DETAIL_DATA = 'aufgaben.setAufgabeDetailData';
export const REFETCH_SINGLE_AUFGABE = 'aufgaben.refetchSingleAufgabeAndUpdate';

export const DELETE_BEOBACHTER = 'aufgaben.deleteBeobachter';
export const ADD_BEOBACHTER = 'aufgaben.addBeobachter';

export const GET_MIR_ZUGEWIESEN_COUNT = 'aufgaben.getMirZugewiesenCount';
export const SET_MIR_ZUGEWIESEN_COUNT = 'aufgaben.setMirZugewiesenCount';

export const GET_TEAM_ANSICHT_COUNT = 'aufgaben.getTeamAnsichtCount';
export const SET_TEAM_ANSICHT_COUNT = 'aufgaben.setTeamAnsichtCount';

export const GET_FILTER_OPTIONS = 'aufgaben.getFilterOptions';
export const GET_FILTER_OPTIONS_ATTACHMENTS = 'aufgaben.getFilterOptionsAttachments';

// comments
export const SAVE_COMMENT = 'aufgaben.saveComment';
export const SAVE_REACTION = 'aufgaben.saveReaction';
export const DELETE_REACTION = 'aufgaben.deleteReaction';
export const DELETE_COMMENT = 'aufgaben.deleteComment';
export const SAVE_EDIT_COMMENT = 'aufgaben.saveEditComment';
export const SAVE_REPLY_COMMENT = 'aufgaben.saveReplyComment';
export const SET_IS_COMMENTS_BUSY = 'aufgaben.setIsCommentsBusy';

// comment setters
export const SET_EDIT_COMMENT_ID = 'aufgaben.setEditCommentId';
export const SET_REPLY_COMMENT_ID = 'aufgaben.setReCommentId';
export const SET_COMMENT_TEXT = 'aufgaben.setCommentText';
export const SET_MODE = 'aufgaben.setMode';

//filters
export const SET_FILTER_ANSICHT = 'aufgaben.setFilterAnsicht';

export const SET_AUFGABEN_COUNT = 'aufgaben.setAufgabenCount';
export const DECREMENT_AUFGABEN_COUNT = 'aufgaben.decrementAufgabenCount';

export const SET_COMMENTS_AUFGABEN_DETAIL = 'aufgaben.setCommentsAufgabenDetail';

// Lazy Loading der Tab-Daten
export const FETCH_VERLINKUNGEN_DATA = 'aufgaben.fetchVerlinkungenData';
export const FETCH_LEISTUNGEN_DATA = 'aufgaben.fetchLeistungenData';
export const SET_IS_VERLINKUNGEN_LOADING = 'aufgaben.setIsVerlinkungenLoading';
export const SET_IS_LEISTUNGEN_LOADING = 'aufgaben.setIsLeistungenLoading';

const state = () => ({
  aufgaben: [],
  isBusy: false,
  isAufgabeUpdating: false,
  // Loading-States für Lazy Loading der Tab-Daten
  isVerlinkungenLoading: false,
  isLeistungenLoading: false,
  isCommentsBusy: false,
  filters: {
    // options: 'Mir zugewiesen', 'Von mir erstellt', 'Von mir beobachtet', 'Team',
    // 'Vom Team erstellt', 'Abteilung', 'Von Abteilung erstellt', 'Alle Aufgaben'
    ansicht: 'Mir zugewiesen',
  },
  aufgabeDetail: null,
  timeUpdated: null,
  count: null,
  notificationCount: 0,
  comments: {
    editCommentId: null,
    replyCommentId: null,
    commentText: '',
    mode: '',
  },
  mirZugewiesenCount: 0,
  teamAnsichtCount: 0,
  reiseterminKuerzelFilterOptions: null,
});
const getters = {
  getCommentsFromSelectedAufgabe(state) {
    const answers = state.aufgabeDetail?.comments.filter(comment => comment.parentId !== null);
    const commentsWithAnswers = state.aufgabeDetail?.comments
      .filter(comment => comment.parentId === null)
      .map(comment => {
        const matchingAnswers = answers.filter(answer => answer.parentId === comment.id);
        if (matchingAnswers.length > 0) {
          return { ...comment, answers: matchingAnswers };
        } else return { ...comment, answers: [] };
      })
      .sort((a, b) => new Date(b.createdDateUtc) - new Date(a.createdDateUtc));
    return commentsWithAnswers;
  },
};
const actions = {
  [ADD_BEOBACHTER](context, params) {
    const { id, userId } = params;
    return apiService.post('/aufgaben/beobachter', { id, beobachter: userId }).then(async () => {
      const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
        aufgabenId: id,
      });
      context.state.aufgabeDetail = updatedAufgabe;
      context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
        if (aufgabe.id === id) {
          return updatedAufgabe;
        } else return aufgabe;
      });
      return updatedAufgabe;
    });
  },
  [DELETE_BEOBACHTER](context, params) {
    const { id, userId } = params;
    return apiService.delete('/aufgaben/beobachter', { id, beobachter: userId }).then(async () => {
      const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
        aufgabenId: id,
      });
      context.state.aufgabeDetail = updatedAufgabe;
      context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
        if (aufgabe.id === id) {
          return updatedAufgabe;
        } else return aufgabe;
      });
      return updatedAufgabe;
    });
  },
  [INITIALLY_GET_AUFGABEN_NOTIFICATION_COUNT](context) {
    if (!context.state.timeUpdated || moment().diff(moment(context.state.timeUpdated), 'minutes') > 1) {
      const currentUser = context.rootGetters['currentUserId'];
      context.commit(SET_TIME_UPDATED, moment());
      context.commit(SET_IS_BUSY, true);
      const count = true;
      const odataFilter = buildQuery({
        filter: getAufgabenNotificationFilter(context.rootGetters.getAllUsers ?? [], currentUser),
        count,
        top: 0,
      });
      return apiService
        .get('/aufgaben' + odataFilter)
        .then(response => {
          context.commit(SET_AUFGABEN_NOTIFICATION_COUNT, response.data.result['@odata.count'] || 0);
          return response.data;
        })
        .finally(_ => context.commit(SET_IS_BUSY, false));
    }
  },
  [GET_AUFGABEN_NOTIFICATION_COUNT](context) {
    const currentUser = context.rootGetters['currentUserId'];
    context.commit(SET_TIME_UPDATED, moment());
    context.commit(SET_IS_BUSY, true);
    const count = true;
    const odataFilter = buildQuery({
      filter: getAufgabenNotificationFilter(context.rootGetters.getAllUsers ?? [], currentUser),
      count,
      top: 0,
    });
    return apiService
      .get('/aufgaben' + odataFilter)
      .then(response => {
        context.commit(SET_AUFGABEN_NOTIFICATION_COUNT, response.data.result['@odata.count'] || 0);
        return response.data;
      })
      .finally(_ => context.commit(SET_IS_BUSY, false));
  },
  [GET_MIR_ZUGEWIESEN_COUNT](context) {
    const currentUser = context.rootGetters['currentUserId'];
    context.commit(SET_IS_BUSY, true);
    const count = true;
    // query anzahl der Aufgaben, die der eingeloggten Person zugewiesen und offen sind
    const odataFilter = buildQuery({
      filter: {
        bearbeiter: currentUser,
        status: { in: ['Offen'] },
      },
      count,
      top: 0,
    });
    return apiService
      .get('/aufgaben' + odataFilter)
      .then(response => {
        context.commit(SET_MIR_ZUGEWIESEN_COUNT, response.data.result['@odata.count'] || 0);
        return response.data;
      })
      .finally(_ => context.commit(SET_IS_BUSY, false));
  },
  [GET_TEAM_ANSICHT_COUNT](context) {
    const currentUser = context.rootGetters['currentUserId'];
    context.commit(SET_IS_BUSY, true);
    const count = true;
    const allUsers = context.rootGetters.getAllUsers;
    const { teamsOfUser, membersOfTeam } = resolveTeamContext(allUsers, currentUser);
    if (!teamsOfUser.length) {
      context.commit(SET_TEAM_ANSICHT_COUNT, 0);
      context.commit(SET_IS_BUSY, false);
      return Promise.resolve();
    }
    // query anzahl der Aufgaben der Team-Ansicht (eigenes Team oder Team-Mitglieder als Bearbeiter) im Standard-Statusfilter
    const odataFilter = buildQuery({
      filter: {
        or: [{ bearbeiter: { in: membersOfTeam } }, { team: { in: teamsOfUser } }],
        status: { in: ['Offen'] },
      },
      count,
      top: 0,
    });
    return apiService
      .get('/aufgaben' + odataFilter)
      .then(response => {
        context.commit(SET_TEAM_ANSICHT_COUNT, response.data.result['@odata.count'] || 0);
        return response.data;
      })
      .finally(_ => context.commit(SET_IS_BUSY, false));
  },
  [GET_AUFGABEN](context, request) {
    const odataFilters = getOdataFilterFromRequest(request, context);
    context.commit(SET_IS_BUSY, true);
    return apiService
      .get('/aufgaben' + odataFilters)
      .then(response => {
        context.commit(SET_AUFGABEN, response?.data?.result?.value);
        context.commit(SET_AUFGABEN_COUNT, response.data.result['@odata.count'] || 0);
        return response.data;
      })
      .finally(_ => context.commit(SET_IS_BUSY, false));
  },
  [CREATE_AUFGABE](context, params) {
    context.commit(SET_IS_BUSY, true);
    return apiService
      .post('/aufgaben/', params)
      .then(response => {
        context.dispatch(GET_AUFGABEN_NOTIFICATION_COUNT);
        context.dispatch(GET_MIR_ZUGEWIESEN_COUNT);
        context.dispatch(GET_TEAM_ANSICHT_COUNT);
        return response;
      })
      .finally(_ => context.commit(SET_IS_BUSY, false));
  },
  [EDIT_AUFGABE](context, params) {
    context.commit(SET_IS_AUFGABE_UPDATING, true);
    return apiService
      .put('/aufgaben/?id=' + params.id, params)
      .then(async () => {
        const prevDetail = context.state.aufgabeDetail;
        const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: prevDetail.id,
        });

        // Lazy-geladene Tab-Daten aus prevDetail übernehmen, damit sie beim
        // Refetch (der nur Minimalfelder expandiert) nicht verloren gehen.
        if (prevDetail.leistungen?.some(leistung => leistung.kreditor !== undefined)) {
          updatedAufgabe.leistungen = prevDetail.leistungen;
        }
        if (prevDetail.reiseTermine?.some(reisetermin => reisetermin.reise !== undefined)) {
          updatedAufgabe.reiseTermine = prevDetail.reiseTermine;
        }
        if (prevDetail.dateien?.length) {
          updatedAufgabe.dateien = prevDetail.dateien;
        }
        if (prevDetail.vorgaenge?.length) {
          updatedAufgabe.vorgaenge = prevDetail.vorgaenge;
        }
        if (prevDetail.reisen?.length) {
          updatedAufgabe.reisen = prevDetail.reisen;
        }
        if (prevDetail.flugverfuegbarkeiten?.length) {
          updatedAufgabe.flugverfuegbarkeiten = prevDetail.flugverfuegbarkeiten;
        }

        context.state.aufgabeDetail = updatedAufgabe;
        context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
          if (aufgabe.id === context.state.aufgabeDetail.id) {
            return updatedAufgabe;
          } else return aufgabe;
        });
        context.dispatch(GET_AUFGABEN_NOTIFICATION_COUNT);
        context.dispatch(GET_MIR_ZUGEWIESEN_COUNT);
        context.dispatch(GET_TEAM_ANSICHT_COUNT);
        return updatedAufgabe;
      })
      .finally(_ => context.commit(SET_IS_AUFGABE_UPDATING, false));
  },
  [LOAD_TRIGGERS](context, params) {
    return apiService.get('/aufgaben/statemachine/trigger?id=' + params.aufgabeId).then(response => {
      if (response.data.result?.trigger) {
        return response.data.result?.trigger;
      }
    });
  },
  [EDIT_STATUS](context, params) {
    context.commit(SET_IS_AUFGABE_UPDATING, true);

    // Beim Setzen auf "In Arbeit" wird der aktuelle User automatisch als Bearbeiter übernommen
    const currentAufgabe = context.state.aufgabeDetail;
    const currentUserId = context.rootGetters['currentUserId'];
    const shouldAssignCurrentUser =
      params.trigger === 'TriggerInArbeit' &&
      currentAufgabe?.id === params.aufgabeId &&
      (currentAufgabe?.bearbeiter !== currentUserId || !!currentAufgabe?.team);

    const assignCurrentUserPromise = shouldAssignCurrentUser
      ? apiService.put('/aufgaben/?id=' + params.aufgabeId, {
          id: params.aufgabeId,
          beschreibung: currentAufgabe.beschreibung,
          faelligkeitsdatum: currentAufgabe.faelligkeitsdatum,
          prioritaet: currentAufgabe.prioritaet,
          bearbeiter: currentUserId,
          team: null,
        })
      : Promise.resolve();

    return assignCurrentUserPromise
      .then(() => apiService.put('/aufgaben/statemachine/trigger?aufgabeId=' + params.aufgabeId, params))
      .then(async _ => {
        const prevDetail = context.state.aufgabeDetail;
        const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: prevDetail.id,
        });
        context.dispatch(GET_AUFGABEN_NOTIFICATION_COUNT);
        context.dispatch(GET_MIR_ZUGEWIESEN_COUNT);
        context.dispatch(GET_TEAM_ANSICHT_COUNT);

        if (prevDetail.leistungen?.some(leistung => leistung.kreditor !== undefined)) {
          updatedAufgabe.leistungen = prevDetail.leistungen;
        }

        if (prevDetail.reiseTermine?.some(reisetermin => reisetermin.reise !== undefined)) {
          updatedAufgabe.reiseTermine = prevDetail.reiseTermine;
        }

        if (prevDetail.dateien?.length) {
          updatedAufgabe.dateien = prevDetail.dateien;
        }

        if (prevDetail.vorgaenge?.length) {
          updatedAufgabe.vorgaenge = prevDetail.vorgaenge;
        }

        if (prevDetail.reisen?.length) {
          updatedAufgabe.reisen = prevDetail.reisen;
        }

        if (prevDetail.flugverfuegbarkeiten?.length) {
          updatedAufgabe.flugverfuegbarkeiten = prevDetail.flugverfuegbarkeiten;
        }

        context.state.aufgabeDetail = updatedAufgabe;
        context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
          if (aufgabe.id === updatedAufgabe.id) {
            return updatedAufgabe;
          } else return aufgabe;
        });
        return updatedAufgabe;
      })
      .finally(_ => context.commit(SET_IS_AUFGABE_UPDATING, false));
  },
  [BULK_EDIT_STATUS](context, params) {
    context.commit(SET_IS_AUFGABE_UPDATING, true);
    return apiService
      .put('/aufgaben/statemachine/trigger/bulk', {
        aufgabeIds: params.aufgabeIds,
        trigger: params.trigger,
      })
      .then(response => {
        context.dispatch(GET_AUFGABEN_NOTIFICATION_COUNT);
        context.dispatch(GET_MIR_ZUGEWIESEN_COUNT);
        context.dispatch(GET_TEAM_ANSICHT_COUNT);
        return response.data;
      })
      .finally(_ => context.commit(SET_IS_AUFGABE_UPDATING, false));
  },
  [SAVE_COMMENT](context, params) {
    context.commit(SET_IS_COMMENTS_BUSY, true);
    let { text } = params;
    return apiService
      .post('/Comments', {
        aufgabeId: context.state.aufgabeDetail.id,
        text,
      })
      .then(async () => {
        context.commit(SET_IS_COMMENTS_BUSY, false);
        // Optimistic update of local comment list
        const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: context.state.aufgabeDetail.id,
        });
        context.state.aufgabeDetail = updatedAufgabe;
        context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
          if (aufgabe.id === context.state.aufgabeDetail.id) {
            return updatedAufgabe;
          } else return aufgabe;
        });
        return updatedAufgabe;
      })
      .catch(() => context.commit(SET_IS_COMMENTS_BUSY, false));
  },
  [SAVE_REACTION](context, params) {
    context.commit(SET_IS_COMMENTS_BUSY, true);

    return apiService
      .post('/Comments', {
        aufgabeId: context.state.aufgabeDetail.id,
        text: params.text,
        parentId: params.replyCommentId,
      })
      .then(async () => {
        context.commit(SET_IS_COMMENTS_BUSY, false);
        context.commit(SET_MODE, '');
        context.commit(SET_COMMENT_TEXT, '');
        context.commit(SET_REPLY_COMMENT_ID, null);

        const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: context.state.aufgabeDetail.id,
        });
        context.state.aufgabeDetail = updatedAufgabe;
        context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
          if (aufgabe.id === context.state.aufgabeDetail.id) {
            return updatedAufgabe;
          } else return aufgabe;
        });
        return updatedAufgabe;
      })
      .finally(() => context.commit(SET_IS_COMMENTS_BUSY, false));
  },
  [DELETE_REACTION](context, params) {
    context.commit(SET_IS_COMMENTS_BUSY, true);

    return apiService
      .delete('/Comments?commentId=' + params.commentId, {
        CommentId: params.commentId,
      })
      .then(async () => {
        context.commit(SET_IS_COMMENTS_BUSY, false);
        context.commit(SET_MODE, '');
        context.commit(SET_COMMENT_TEXT, '');
        context.commit(SET_REPLY_COMMENT_ID, null);

        const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: context.state.aufgabeDetail.id,
        });
        context.state.aufgabeDetail = updatedAufgabe;
        context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
          if (aufgabe.id === context.state.aufgabeDetail.id) {
            return updatedAufgabe;
          } else return aufgabe;
        });
        return updatedAufgabe;
      })
      .finally(() => context.commit(SET_IS_COMMENTS_BUSY, false));
  },
  [DELETE_COMMENT](context, params) {
    context.commit(SET_IS_COMMENTS_BUSY, true);

    return apiService
      .delete('Comments?commentId=' + params.commentId, {
        CommentId: params.commentId,
      })
      .then(async () => {
        context.commit(SET_IS_COMMENTS_BUSY, false);
        // Optimistic update of local comment list
        const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: context.state.aufgabeDetail.id,
        });
        context.state.aufgabeDetail = updatedAufgabe;
        context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
          if (aufgabe.id === context.state.aufgabeDetail.id) {
            return updatedAufgabe;
          } else return aufgabe;
        });
        return updatedAufgabe;
      })
      .finally(() => context.commit(SET_IS_COMMENTS_BUSY, false));
  },
  // Lädt nur die Kerndaten der Aufgabe + Leistung-IDs und Reiseterminkürzel
  [REFETCH_SINGLE_AUFGABE](context, params) {
    context.commit(SET_IS_AUFGABE_UPDATING, true);
    const odataQuery = buildQuery({
      expand: {
        comments: {},
        leistungen: { select: ['id', 'Bnr'], filter: { deletedAt: null } },
        reisetermine: { select: ['id', 'reiseterminkuerzel'] },
      },
      filter: { id: params.aufgabenId },
    });

    return apiService
      .get('/aufgaben' + odataQuery)
      .then(response => {
        return response.data.result.value?.[0];
      })
      .finally(() => context.commit(SET_IS_AUFGABE_UPDATING, false));
  },
  // Lazy Loading der vollständigen Verlinkungen-Daten
  [FETCH_VERLINKUNGEN_DATA](context, params) {
    context.commit(SET_IS_VERLINKUNGEN_LOADING, true);
    const odataQuery = buildQuery({
      expand: {
        reisetermine: {
          expand: {
            ersatztermin: { select: ['id'] },
            flugeinkauf: { expand: { Gruppeneinkaeufe: {} } },
            metadata: {
              expand: {
                ZiellandAbflughaefen: { select: ['flughafenIataCode', 'isPrio'] },
                ZiellandZielflughaefen: { select: ['flughafenIataCode', 'isPrio'] },
                Inlandsfluege: {},
                PlanZimmerkontingente: {},
              },
            },
            pax: {},
            comments: { select: ['id'] },
            countryManagers: { select: 'countryManagerKuerzel' },
            reise: {
              expand: {
                fullMetadataHistory: {
                  filter: { Reisetermin: null },
                  select: ['gueltigAb'],
                  expand: { CountryManagers: { select: 'countryManagerKuerzel' } },
                },
              },
            },
            gueltigeKonfiguration: {
              select: [
                'versicherungsnachweisRequired',
                'verzichtserklaerungRequired',
                'loiAntragRequired',
                'referenznummerAntragRequired',
              ],
            },
            zimmerkontingente: {
              select: [
                'id',
                'isDeleted',
                'zimmertyp',
                'verfuegbarkeitsStatus',
                'einheitenFrei',
                'zuschlag',
                'kontingentAktuellGeteilt',
                'partner',
              ],
            },
            aufgaben: {
              select: [
                'id',
                'kategorie',
                'status',
                'bearbeiter',
                'faelligkeitsdatum',
                'team',
                'werktageBisFaelligkeit',
              ],
            },
            flugverfuegbarkeiten: {
              orderby: 'abfragedatum desc',
              select: [
                'id',
                'aufpreis',
                'status',
                'abfragedatum',
                'deutscherAbflughafenIataCode',
                'abflughafenIataCode',
                'zielflughafenIataCode',
                'zimmertyp',
                'verpflegung',
              ],
              filter: {
                abfragedatum: { ge: getDate14DaysAgo() },
              },
            },
          },
        },
        vorgaenge: {
          expand: {
            pnrs: {},
            aufgaben: {
              select: [
                'id',
                'kategorie',
                'status',
                'bearbeiter',
                'faelligkeitsdatum',
                'team',
                'werktageBisFaelligkeit',
              ],
            },
            kunde: { expand: { master: { select: ['vorname', 'nachname'] } } },
            hotelleistungen: {
              filter: { isDeleted: false },
              select: ['reiseterminId'],
              expand: {
                reisetermin: { select: ['id'] },
              },
            },
            teilnehmers: {
              filter: { deletedAt: null },
            },
          },
        },
        reisen: {
          select: ['id', 'reisekuerzel', 'titel', 'country', 'region', 'prioritaet'],
          expand: {
            aufgaben: {
              select: [
                'id',
                'kategorie',
                'status',
                'bearbeiter',
                'faelligkeitsdatum',
                'team',
                'werktageBisFaelligkeit',
              ],
            },
          },
        },
        flugverfuegbarkeiten: {
          expand: {
            aufgaben: {
              select: [
                'id',
                'kategorie',
                'status',
                'bearbeiter',
                'faelligkeitsdatum',
                'team',
                'werktageBisFaelligkeit',
              ],
            },
            Reisetermin: {
              expand: {
                reise: {},
                pax: {},
                countryManagers: { select: 'countryManagerKuerzel' },
                metadata: {
                  expand: { ZiellandZielflughaefen: {}, ZiellandAbflughaefen: {}, Inlandsfluege: {} },
                },
                flugeinkauf: { expand: { Gruppeneinkaeufe: {} } },
                gueltigerSaisonpreis: { select: ['thMaxLangstrecke', 'thMaxInlandsflug'] },
              },
            },
            abfragefehler: { select: ['text'] },
          },
        },
        dateien: {},
      },
      filter: { id: params.aufgabenId },
    });

    return apiService
      .get('/aufgaben' + odataQuery)
      .then(async response => {
        const tabData = response.data.result.value?.[0];
        // Die Route releaseprozessStatus liefert immer nur einen Reisetermin, daher ein Request je Tabellenzeile
        // Das Backend liefert die Reisetermine je nach Aufruf als reiseTermine oder reisetermine
        const reisetermine = tabData?.reiseTermine ?? tabData?.reisetermine ?? [];
        const releaseprozessStati = await Promise.all(
          reisetermine.map(reisetermin => getReleaseprozessStatus(reisetermin.id).catch(() => null))
        );
        reisetermine.forEach((reisetermin, index) => {
          reisetermin.releaseprozessStatus = releaseprozessStati[index]?.reisetermin || null;
        });
        // Nur mergen der nachgeladenen Daten wenn die gleiche Aufgabe geöffnet ist
        if (tabData && context.state.aufgabeDetail?.id === params.aufgabenId) {
          context.commit(SET_AUFGABE_DETAIL_DATA, {
            ...context.state.aufgabeDetail,
            reiseTermine: tabData.reiseTermine ?? tabData.reisetermine,
            vorgaenge: tabData.vorgaenge,
            reisen: tabData.reisen,
            flugverfuegbarkeiten: tabData.flugverfuegbarkeiten,
            dateien: tabData.dateien,
          });
        }
        return tabData;
      })
      .finally(() => context.commit(SET_IS_VERLINKUNGEN_LOADING, false));
  },
  // Lazy Loading der vollständigen Leistungsdaten
  [FETCH_LEISTUNGEN_DATA](context, params) {
    context.commit(SET_IS_LEISTUNGEN_LOADING, true);
    const odataQuery = buildQuery({
      expand: {
        leistungen: {
          filter: { deletedAt: null },
          expand: { vorgang: { select: ['npx'] }, freigaben: {} },
        },
      },
      filter: { id: params.aufgabenId },
    });

    return apiService
      .get('/aufgaben' + odataQuery)
      .then(response => {
        const tabData = response.data.result.value?.[0];
        // Nur mergen der nachgeladenen Daten wenn die gleiche Aufgabe geöffnet ist
        if (tabData && context.state.aufgabeDetail?.id === params.aufgabenId) {
          context.commit(SET_AUFGABE_DETAIL_DATA, {
            ...context.state.aufgabeDetail,
            leistungen: tabData.leistungen,
          });
        }
        return tabData;
      })
      .finally(() => context.commit(SET_IS_LEISTUNGEN_LOADING, false));
  },
  [SAVE_EDIT_COMMENT](context, params) {
    context.commit(SET_IS_COMMENTS_BUSY, true);

    const { commentText } = params;

    if (context.state.comments.editCommentId) {
      return apiService
        .put('/Comments?commentId=' + context.state.comments.editCommentId, {
          text: commentText,
          commentId: context.state.comments.editCommentId,
        })
        .then(async () => {
          context.commit(SET_IS_COMMENTS_BUSY, false);
          // Optimistic update of local comment list
          const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
            aufgabenId: context.state.aufgabeDetail.id,
          });
          context.state.aufgabeDetail = updatedAufgabe;
          context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
            if (aufgabe.id === context.state.aufgabeDetail.id) {
              return updatedAufgabe;
            } else return aufgabe;
          });
          context.commit(SET_MODE, '');
          context.commit(SET_COMMENT_TEXT, '');
          context.commit(SET_EDIT_COMMENT_ID, null);
          context.commit(SET_IS_COMMENTS_BUSY, false);

          return updatedAufgabe;
        })
        .catch(() => context.commit(SET_IS_COMMENTS_BUSY, false));
    }
  },
  [SAVE_REPLY_COMMENT](context) {
    context.commit(SET_IS_COMMENTS_BUSY, true);

    return apiService
      .post('/Comments', {
        aufgabeId: context.state.aufgabeDetail.id,
        text: context.state.comments.commentText,
        parentId: context.state.comments.replyCommentId,
      })
      .then(async () => {
        context.commit(SET_IS_COMMENTS_BUSY, false);
        context.commit(SET_MODE, '');
        context.commit(SET_COMMENT_TEXT, '');
        context.commit(SET_REPLY_COMMENT_ID, null);

        const updatedAufgabe = await context.dispatch(REFETCH_SINGLE_AUFGABE, {
          aufgabenId: context.state.aufgabeDetail.id,
        });
        context.state.aufgabeDetail = updatedAufgabe;
        context.state.aufgaben = context.state.aufgaben.map(aufgabe => {
          if (aufgabe.id === context.state.aufgabeDetail.id) {
            return updatedAufgabe;
          } else return aufgabe;
        });
        return updatedAufgabe;
      })
      .finally(() => context.commit(SET_IS_COMMENTS_BUSY, false));
  },
  [GET_FILTER_OPTIONS](context, request) {
    const odataFilters = getOdataFilterForCategories(request, context);
    return apiService
      .get('/aufgaben' + odataFilters)
      .then(response => {
        return response.data.result.value.map(k => k[request.attribute]);
      })
      .finally(_ => context.commit(SET_IS_BUSY, false));
  },
  [GET_FILTER_OPTIONS_ATTACHMENTS](context, request) {
    const filter = getFiltersFromContext(context, request);
    const expand = {
      reisetermine: {
        select: ['reiseterminkuerzel', 'id'],
      },
      reisen: {
        select: ['reisekuerzel', 'id'],
      },
      flugverfuegbarkeiten: {
        select: ['deutscherAbflughafenIataCode', 'id'],
        expand: {
          reisetermin: { select: ['reiseterminkuerzel'] },
        },
      },
      vorgaenge: { select: ['id'] },
    };
    const changedFilters = { filter, select: ['id'], expand };
    return apiService
      .get('/aufgaben' + buildQuery(changedFilters))
      .then(response => {
        return response.data.result.value;
      })
      .finally(_ => context.commit(SET_IS_BUSY, false));
  },
};
const mutations = {
  [SET_MIR_ZUGEWIESEN_COUNT](state, count) {
    state.mirZugewiesenCount = count;
  },
  [SET_TEAM_ANSICHT_COUNT](state, count) {
    state.teamAnsichtCount = count;
  },
  [SET_AUFGABEN](state, aufgaben) {
    state.aufgaben = aufgaben;
  },
  [SET_IS_BUSY](state, isBusy) {
    state.isBusy = isBusy;
  },
  [SET_IS_COMMENTS_BUSY](state, isBusy) {
    state.isCommentsBusy = isBusy;
  },
  [SET_IS_AUFGABE_UPDATING](state, isLoading) {
    state.isAufgabeUpdating = isLoading;
  },
  [SET_IS_VERLINKUNGEN_LOADING](state, isLoading) {
    state.isVerlinkungenLoading = isLoading;
  },
  [SET_IS_LEISTUNGEN_LOADING](state, isLoading) {
    state.isLeistungenLoading = isLoading;
  },
  [SET_FILTER_ANSICHT](state, ansicht) {
    state.filters.ansicht = ansicht;
  },
  [SET_AUFGABE_DETAIL_DATA](state, data) {
    state.aufgabeDetail = data;
  },
  [SET_TIME_UPDATED](state, time) {
    state.timeUpdated = time;
  },
  [SET_AUFGABEN_NOTIFICATION_COUNT](state, notificationCount) {
    state.notificationCount = notificationCount;
  },
  [SET_EDIT_COMMENT_ID](state, editCommentId) {
    state.comments.editCommentId = editCommentId;
  },
  [SET_REPLY_COMMENT_ID](state, replyCommentId) {
    state.comments.replyCommentId = replyCommentId;
  },
  [SET_COMMENT_TEXT](state, commentText) {
    state.comments.commentText = commentText;
  },
  [SET_MODE](state, mode) {
    state.comments.mode = mode;
  },
  [SET_AUFGABEN_COUNT](state, count) {
    state.count = count;
  },
  // Reduziert den Count lokal um eine beliebige Anzahl, wenn Zeilen clientseitig aus der Übersicht
  // entfernt werden ohne dass ein neuer Serverabruf erfolgt
  [DECREMENT_AUFGABEN_COUNT](state, amount = 1) {
    if (state.count !== null && state.count > 0) {
      state.count = Math.max(0, state.count - amount);
    }
  },
  [SET_COMMENTS_AUFGABEN_DETAIL](state, comments) {
    state.aufgabeDetail.comments = comments;
  },
};

const getOdataFilterFromRequest = (request, context) => {
  // startRow => skip
  // endRow-startRow => top
  if (request) {
    const { startRow, endRow, sortModel } = request;
    const top = endRow - startRow;
    const skip = startRow;
    const orderBy =
      sortModel.length > 0
        ? sortModel.map(sortObject => sortObject.colId + ' ' + sortObject.sort).join(',')
        : null;
    const filter = getFiltersFromContext(context, request);
    return buildQuery({
      top,
      skip,
      orderBy,
      filter,
      count: true,
      expand: {
        reisetermine: {
          select: ['reiseterminkuerzel'],
        },
        vorgaenge: {
          select: ['id'],
        },
        reisen: { select: ['reisekuerzel'] },
        flugverfuegbarkeiten: {
          select: ['id', 'deutscherAbflughafenIataCode'],
          expand: {
            reisetermin: { select: ['reiseterminkuerzel'] },
          },
        },
      },
    });
  }
  return '';
};

const getOdataFilterForCategories = (request, context) => {
  if (request) {
    const filter = getFiltersFromContext(context, request);
    return buildQuery({
      filter,
      select: [request.attribute],
    });
  }
  return '';
};

// Team = echte Teams ohne die Abteilung selbst; siehe getUserTeamsOhneAbteilung in utils.js
const resolveTeamContext = (allUsers, userId) => {
  const teamsOfUser = getUserTeamsOhneAbteilung(allUsers.find(u => u.id === userId));
  const membersOfTeam = teamsOfUser.length
    ? allUsers.filter(u => getUserTeams(u).some(t => teamsOfUser.includes(t))).map(u => u.id)
    : [];
  return { teamsOfUser, membersOfTeam };
};

// Abteilung = department; die Teams der Abteilung (z. B. FOM GDS und FOM NDC bei FOM) gehören mit dazu
const resolveAbteilungContext = (allUsers, userId) => {
  const abteilung = allUsers.find(u => u.id === userId)?.department;
  const usersOfAbteilung = abteilung ? allUsers.filter(u => u.department === abteilung) : [];
  const teamsOfAbteilung = [...new Set([abteilung, ...usersOfAbteilung.flatMap(getUserTeams)])].filter(
    Boolean
  );
  return { teamsOfAbteilung, membersOfAbteilung: usersOfAbteilung.map(u => u.id) };
};

// Rote Zahl am Menüpunkt: offene Aufgaben der Person und ihres Teams; ohne Team die ihrer Abteilung
const getAufgabenNotificationFilter = (allUsers, userId) => {
  const { teamsOfUser } = resolveTeamContext(allUsers, userId);
  const teams = teamsOfUser.length ? teamsOfUser : resolveAbteilungContext(allUsers, userId).teamsOfAbteilung;
  return {
    or: [{ bearbeiter: userId }, ...(teams.length ? [{ team: { in: teams } }] : [])],
    status: 'Offen',
  };
};

const getFiltersFromContext = (context, request) => {
  const currentUserId = context.rootGetters['currentUserId'];
  const filterObject = context.state.filters;
  const { filterModel, fakeUser } = request;
  const filterModelLength = Object.keys(filterModel).length;
  let filters = {};

  const allUsers = context.rootGetters.getAllUsers;
  const effectiveUserId = fakeUser !== null ? fakeUser : currentUserId;

  if (filterObject.ansicht === 'Mir zugewiesen') {
    filters = { ...filters, bearbeiter: effectiveUserId };
  } else if (filterObject.ansicht === 'Von mir erstellt') {
    filters = { ...filters, autor: effectiveUserId };
  } else if (filterObject.ansicht === 'Von mir beobachtet') {
    filters = { ...filters, a: ["beobachter/any(d:contains(d,'" + effectiveUserId + "'))"] };
  } else if (filterObject.ansicht === 'Team') {
    const { teamsOfUser, membersOfTeam } = resolveTeamContext(allUsers, effectiveUserId);
    if (teamsOfUser.length) {
      filters = {
        ...filters,
        and: [
          {
            or: [{ bearbeiter: { in: membersOfTeam } }, { team: { in: teamsOfUser } }],
          },
        ],
      };
    }
  } else if (filterObject.ansicht === 'Vom Team erstellt') {
    const { membersOfTeam } = resolveTeamContext(allUsers, effectiveUserId);
    if (membersOfTeam.length) {
      filters = { ...filters, autor: { in: membersOfTeam } };
    }
  } else if (filterObject.ansicht === 'Abteilung') {
    const { teamsOfAbteilung, membersOfAbteilung } = resolveAbteilungContext(allUsers, effectiveUserId);
    if (membersOfAbteilung.length) {
      filters = {
        ...filters,
        and: [
          {
            or: [{ bearbeiter: { in: membersOfAbteilung } }, { team: { in: teamsOfAbteilung } }],
          },
        ],
      };
    }
  } else if (filterObject.ansicht === 'Von Abteilung erstellt') {
    const { membersOfAbteilung } = resolveAbteilungContext(allUsers, effectiveUserId);
    if (membersOfAbteilung.length) {
      filters = { ...filters, autor: { in: membersOfAbteilung } };
    }
  } else if (filterObject.ansicht === 'Alle Aufgaben') {
    // Alle Aufgaben des Unternehmens, daher keine Einschränkung auf Bearbeiter, Autor oder Team
  }

  if (filterModelLength > 0) {
    Object.keys(filterModel).forEach(filterKey => {
      const filterValues = filterModel[filterKey];
      if (filterValues.filterType === 'text') {
        if (filterKey === 'id') {
          if (!isNaN(filterValues.filter)) {
            filters = { ...filters, [filterKey]: parseInt(filterValues.filter) };
          }
        } else {
          filters = { ...filters, [filterKey]: { [filterValues.type]: filterValues.filter } };
        }
      } else if (filterValues.filterType === 'date') {
        if (filterKey === 'createdDateUtc') {
          const dateFrom = new Date(filterValues.dateFrom.substring(0, 10));
          const dateTo = add(new Date(filterValues.dateTo.substring(0, 10)), { hours: 23, minutes: 59 });

          filters = { ...filters, [filterKey]: { ge: dateFrom, le: dateTo } };
        } else {
          const dateFrom = new Date(filterValues.dateFrom.substring(0, 10));
          const dateTo = new Date(filterValues.dateTo.substring(0, 10));

          filters = { ...filters, [filterKey]: { ge: dateFrom, le: dateTo } };
        }
      } else if (filterValues.filterType === 'set') {
        if (filterKey === 'attachmentAufgabe') {
          const { attachmentFilterData } = request;
          const filter = {};
          filterValues.values.forEach(item => {
            // Vorgang
            if (!isNaN(parseInt(item))) {
              if ('vorgaenge' in filter) {
                filter['vorgaenge'] = [...filter['vorgaenge'], +item];
              } else filter['vorgaenge'] = [+item];
            }
            if (item.length === 6) {
              if ('reisen' in filter) {
                filter['reisen'] = [...filter['reisen'], item];
              } else filter['reisen'] = [item];
            }
            if (item.length === 17) {
              if ('reisetermine' in filter) {
                filter['reisetermine'] = [...filter['reisetermine'], item];
              } else filter['reisetermine'] = [item];
            }
            if (item.length === 21) {
              if ('flugverfuegbarkeiten' in filter) {
                filter['flugverfuegbarkeiten'] = [
                  ...filter['flugverfuegbarkeiten'],
                  +attachmentFilterData[item],
                ];
              } else {
                filter['flugverfuegbarkeiten'] = [+attachmentFilterData[item]];
              }
            }
          });
          const odataFilter = [];
          for (const [key, value] of Object.entries(filter)) {
            console.log(key, value);
            if (key === 'flugverfuegbarkeiten') {
              odataFilter.push({
                flugverfuegbarkeiten: {
                  any: {
                    id: { in: value },
                  },
                },
              });
            }
            if (key === 'reisetermine') {
              odataFilter.push({
                reisetermine: {
                  any: {
                    reiseterminkuerzel: { in: value },
                  },
                },
              });
            }
            if (key === 'reisen') {
              odataFilter.push({
                reisen: {
                  any: {
                    reisekuerzel: { in: value },
                  },
                },
              });
            }
            if (key === 'vorgaenge') {
              odataFilter.push({
                vorgaenge: {
                  any: {
                    id: { in: value },
                  },
                },
              });
            }
          }
          console.log(odataFilter);
          filters = { ...filters, or: odataFilter };
        } else {
          filters = { ...filters, [filterKey]: { in: filterValues.values } };
        }
      }
    });
  }

  // filter out closed aufgaben if filter not present
  if (!Object.keys(filterModel).includes('status') && !Object.keys(filterModel).includes('id')) {
    if (request.pendingCheckbox) {
      filters = { ...filters, status: { in: ['Offen', 'InArbeit', 'Pending'] } };
    } else {
      filters = { ...filters, status: { in: ['Offen', 'InArbeit', 'Erledigt'] } };
    }
  }

  // if id filter is present, reset bearbeiter
  if (Object.keys(filterModel).includes('id')) {
    delete filters['bearbeiter'];
  }
  return filters;
};
function getDate14DaysAgo() {
  const currentDate = new Date();
  const date14DaysAgo = subDays(currentDate, 14);
  return date14DaysAgo;
}
export default {
  state,
  actions,
  getters,
  mutations,
};
